/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { updateVehicleStatusValues } from '../fn/vehicle-status-controller/update-vehicle-status-values';
import { UpdateVehicleStatusValues$Params } from '../fn/vehicle-status-controller/update-vehicle-status-values';

@Injectable({ providedIn: 'root' })
export class VehicleStatusControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateVehicleStatusValues()` */
  static readonly UpdateVehicleStatusValuesPath = '/box-products/vehicle-status';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateVehicleStatusValues()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateVehicleStatusValues$Response(params?: UpdateVehicleStatusValues$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateVehicleStatusValues(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateVehicleStatusValues$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateVehicleStatusValues(params?: UpdateVehicleStatusValues$Params, context?: HttpContext): Observable<void> {
    return this.updateVehicleStatusValues$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
